import { Alert } from 'react-bootstrap';
import { formatCurrency } from '../../../../utils/formatters';
import { MAX_CARES_GRANTS, MAX_CARES_AMOUNT, FUND_TYPES } from '../../../../constants/constants';
import getProgramYear from '../../../../utils/ProgramYear';

const CaresBenefitDiff = ({
  fundType,
  newEnergyDiscount,
  currentEnergyDiscount,
}) => {
  if (newEnergyDiscount === '' || (currentEnergyDiscount !== newEnergyDiscount && newEnergyDiscount !== 0)) return <></>;

  const alertHeaderText = () => {
    if (newEnergyDiscount === 0)
      return `Customer ineligible for CARES discount.`;

    if (currentEnergyDiscount === newEnergyDiscount)
      return `No tier change.`;
  }
 
  const alertBodyText = () => {
    var bodyText = '';
    if (currentEnergyDiscount === newEnergyDiscount) {
      bodyText += 'Discount remains the same. ';
    } else if (newEnergyDiscount === 0) {
      bodyText += 'Customer is not eligible for a rate discount at this time. ';
    }
    
    bodyText += 'Continue to submit application to ';

    if (fundType === FUND_TYPES.LIHEAP) {
        bodyText += `create a LIHEAP grant and `;
    }
    bodyText += `track this self-declaration.`;
    return bodyText;
  }

  return (
    <>
      <Alert id="caresAlert" variant="info" className="mt-3 mb-0">
          <Alert.Heading>{alertHeaderText()}</Alert.Heading>
          <hr />
          <p className="mb-0">{alertBodyText()}</p>
      </Alert>
    </>
  );
};

export default CaresBenefitDiff;